export default
{
    name: 'app-btn-radio',

    props:
    {
        selected: { type: Boolean, default: false }
    }
}


// WEBPACK FOOTER //
// ./src/scripts/components/app-btn-radio/script.js